import React from 'react'
import { fetchAds } from 'careers/actions/job-ad'
import JobAdList from 'careers/components/job-ad-list'
import FetchWithSpinner from 'components/fetch-with-spinner'

/**
 * Careers index page aka job ad listing
 */

interface IndexProps {
  params: {
    language: string
    companySlug: string
  }
}

function Index({ params }: IndexProps) {
  return (
    <FetchWithSpinner action={() => fetchAds(params)}>
      <JobAdList />
    </FetchWithSpinner>
  )
}

export default Index
